// @flow

export const styles = {
  container: {
    width: '100%',
    marginTop: 100,
    marginBottom: 130,
    background: '#EDEDED',
    '& img': {
      marginBottom: 0,
      zIndex: 100,
      padding: 0,
      position: 'relative',
      top: 130,
      background: '#656565',
      border: '5px solid #000000',
      borderRadius: 5,
      boxShadow: '-39px 36px 85px rgba(0,0,0,.14)'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Styles/ImageModule.Style.js